var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.3,
    height: 21.3,
    viewBox: "0 0 15.3 21.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-user{stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.6 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-user",
    d: "M15.375,3.75a3.75,3.75,0,1,1-3.75,3.75,3.75,3.75,0,0,1,3.75-3.75m0-1.5a5.25,5.25,0,1,0,5.25,5.25,5.25,5.25,0,0,0-5.25-5.25Z",
    transform: "translate(-1.125 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-user",
    d: "M21.75,29.25h-1.5V25.5a3.75,3.75,0,0,0-3.75-3.75H12A3.75,3.75,0,0,0,8.25,25.5v3.75H6.75V25.5A5.25,5.25,0,0,1,12,20.25h4.5a5.25,5.25,0,0,1,5.25,5.25Z",
    transform: "translate(0 -6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ded898fe937eb4797aaaf6db031f1101.svg";
export { ForwardRef as ReactComponent };